import { render, staticRenderFns } from "./SalariePrintSyntetic.vue?vue&type=template&id=4180821b&scoped=true"
import script from "./SalariePrintSyntetic.vue?vue&type=script&lang=js"
export * from "./SalariePrintSyntetic.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintSyntetic.vue?vue&type=style&index=0&id=4180821b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4180821b",
  null
  
)

export default component.exports